module.exports = require("core-js/modules/es.array.splice.js");